import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const personVoiceFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type PersonVoiceFilledProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof personVoiceFilledVariants> &
  IconProps;

export const PersonVoiceFilled = React.forwardRef<
  SVGSVGElement,
  PersonVoiceFilledProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          personVoiceFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox}
        width={width}
        {...props}
      >
        <path d="M19.0248 1.37518C18.9121 1.26251 18.7593 1.19922 18.6 1.19922C18.4406 1.19922 18.2878 1.26251 18.1752 1.37518C18.0625 1.48784 17.9992 1.64065 17.9992 1.79998C17.9992 1.95931 18.0625 2.11211 18.1752 2.22478C19.5384 3.58678 20.25 5.66878 20.25 7.79998C20.25 9.93118 19.5384 12.0132 18.1752 13.3752C18.0625 13.4878 17.9992 13.6406 17.9992 13.8C17.9992 13.9593 18.0625 14.1121 18.1752 14.2248C18.2878 14.3374 18.4406 14.4007 18.6 14.4007C18.7593 14.4007 18.9121 14.3374 19.0248 14.2248C20.6616 12.5868 21.45 10.1688 21.45 7.79998C21.45 5.43118 20.6616 3.01318 19.0248 1.37518ZM16.6248 3.77518C16.569 3.71939 16.5027 3.67514 16.4299 3.64495C16.357 3.61476 16.2788 3.59922 16.2 3.59922C16.1211 3.59922 16.0429 3.61476 15.9701 3.64495C15.8972 3.67514 15.8309 3.71939 15.7752 3.77518C15.7194 3.83096 15.6751 3.89719 15.6449 3.97008C15.6147 4.04296 15.5992 4.12108 15.5992 4.19998C15.5992 4.27887 15.6147 4.35699 15.6449 4.42988C15.6751 4.50276 15.7194 4.56899 15.7752 4.62478C16.5372 5.38678 16.95 6.56878 16.95 7.79998C16.95 9.03118 16.5372 10.2132 15.7752 10.9752C15.6625 11.0878 15.5992 11.2406 15.5992 11.4C15.5992 11.5593 15.6625 11.7121 15.7752 11.8248C15.8878 11.9374 16.0406 12.0007 16.2 12.0007C16.3593 12.0007 16.5121 11.9374 16.6248 11.8248C17.6628 10.7868 18.15 9.26878 18.15 7.79998C18.15 6.33118 17.6628 4.81318 16.6248 3.77518ZM4.79995 8.39998C4.79995 7.12694 5.30566 5.90604 6.20584 5.00586C7.10601 4.10569 8.32691 3.59998 9.59995 3.59998C10.873 3.59998 12.0939 4.10569 12.9941 5.00586C13.8942 5.90604 14.4 7.12694 14.4 8.39998C14.4 9.67302 13.8942 10.8939 12.9941 11.7941C12.0939 12.6943 10.873 13.2 9.59995 13.2C8.32691 13.2 7.10601 12.6943 6.20584 11.7941C5.30566 10.8939 4.79995 9.67302 4.79995 8.39998ZM1.19995 16.8C1.19995 15.4644 2.28355 14.4 3.61075 14.4H15.6C16.2365 14.4 16.8469 14.6528 17.297 15.1029C17.7471 15.553 18 16.1635 18 16.8C18 18.8292 17.0004 20.3592 15.438 21.3564C13.8996 22.3368 11.826 22.8 9.59995 22.8C7.37395 22.8 5.30035 22.3368 3.76195 21.3564C2.19955 20.3604 1.19995 18.828 1.19995 16.8Z" />
      </svg>
    );
  },
);

PersonVoiceFilled.displayName = 'PersonVoiceFilled';
